export default function Footer() {
  return (
    <footer className="bg-stone-800 py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src="https://www.archiconservices.com/img/logo.jpg" alt="Archicon Services" className="w-10 h-10 rounded object-cover" />
              <span className="text-white font-semibold text-sm tracking-widest uppercase" style={{ fontFamily: "'Inter', sans-serif" }}>Archicon Services</span>
            </div>
            <p className="text-stone-400 text-xs leading-relaxed mb-4" style={{ fontFamily: "'Inter', sans-serif" }}>
              Architectural design, construction drawings, 3D rendering, and renovation planning for residential and commercial projects in Houston, TX.
            </p>
            <a href="https://www.facebook.com/profile.php?id=100067606007510" target="_blank" rel="nofollow noopener noreferrer" className="inline-flex w-8 h-8 items-center justify-center border border-white/20 rounded-sm text-white/50 hover:text-white hover:border-white/50 transition-colors cursor-pointer">
              <i className="ri-facebook-fill text-sm"></i>
            </a>
          </div>
          <div>
            <h4 className="text-white text-xs tracking-widest uppercase font-medium mb-5" style={{ fontFamily: "'Inter', sans-serif" }}>Architectural Services</h4>
            <div className="flex flex-col gap-2 text-stone-400 text-xs" style={{ fontFamily: "'Inter', sans-serif" }}>
              <p><strong className="text-stone-300">Archicon Services, Inc.</strong></p>
              <p>Attn: Tarit K. Chaudhuri, AIA, CCIM, BCB</p>
              <p>12111 Gladewick Drive<br />Houston, TX 77077</p>
              <a href="tel:+17139276666" className="hover:text-amber-400 transition-colors cursor-pointer">(713) 927-6666</a>
              <a href="mailto:tarit@archiconservices.com" className="hover:text-amber-400 transition-colors cursor-pointer">tarit@archiconservices.com</a>
            </div>
          </div>
          <div>
            <h4 className="text-white text-xs tracking-widest uppercase font-medium mb-5" style={{ fontFamily: "'Inter', sans-serif" }}>Real Estate Services</h4>
            <div className="flex flex-col gap-2 text-stone-400 text-xs" style={{ fontFamily: "'Inter', sans-serif" }}>
              <p><strong className="text-stone-300">KW Commercial Texas Gulf</strong></p>
              <p>Keller Williams Realty Memorial</p>
              <p>1220 Augusta, Suite #300<br />Houston, TX 77057</p>
              <a href="tel:+17139276666" className="hover:text-amber-400 transition-colors cursor-pointer">(713) 927-6666</a>
              <a href="mailto:realty@archiconservices.com" className="hover:text-amber-400 transition-colors cursor-pointer">realty@archiconservices.com</a>
            </div>
          </div>
        </div>
        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-stone-500 text-xs" style={{ fontFamily: "'Inter', sans-serif" }}>© 2026 Archicon Services, Inc. All rights reserved.</p>
          <p className="text-stone-600 text-xs" style={{ fontFamily: "'Inter', sans-serif" }}>Houston Architectural Design · Construction Drawings · 3D Rendering</p>
        </div>
      </div>
    </footer>
  );
}
